module.exports = __webpack_public_path__ + "static/media/16.8d287458.jpg";